export default "__VITE_ASSET__4f995832__"